import React from 'react';
import { Badge, Container, Heading, Text } from '@chakra-ui/react';
import { RestaurantHeaderProps } from '../../../type';

const RestaurantHeader: React.FC<RestaurantHeaderProps> = (props: RestaurantHeaderProps) => {
  return (
    <Container centerContent={false} py={16}>
      <Badge bg='red.400' color='white' size='lg'>
        추천
      </Badge>
      <Heading fontSize={['xl', '3xl']}>이런 음식점들이 있어요</Heading>
      <Text>검색 결과 {props.count}곳</Text>
    </Container>
  );
};

export default RestaurantHeader;
